import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { registrationApi } from "../api/registration";
import { Field, ProblemAlert } from "../components/ui";

/** "Forgot my password": emails a 15-minute reset link if the address belongs to an account. */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const forgot = useMutation({ mutationFn: registrationApi.forgot });
  function onSubmit(e: FormEvent) {
    e.preventDefault();
    forgot.mutate(email);
  }
  return (
    <main className="login">
      <section className="login__card" aria-labelledby="forgot-title">
        <p className="brand">RegiGov</p>
        <h1 id="forgot-title">Reset your password</h1>
        {forgot.data ? (
          <>
            <p role="status" className="notice">
              {forgot.data.message}
            </p>
            <p className="muted">The link lasts 15 minutes and works once.</p>
          </>
        ) : (
          <form onSubmit={onSubmit} className="form">
            <p className="muted">
              Enter the email address on your account and we will email you a
              link to choose a new password.
            </p>
            <Field label="Email address">
              <input
                name="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={forgot.isPending}
              />
            </Field>
            <ProblemAlert error={forgot.error} />
            <button type="submit" disabled={forgot.isPending}>
              {forgot.isPending ? "Sending…" : "Email me a reset link"}
            </button>
          </form>
        )}
        <p>
          <Link to="/login">Back to sign in</Link>
        </p>
      </section>
    </main>
  );
}
